import React from "react";
import ExlyImage from "common/Components/ExlyImage";
import { locked_svg } from "./constants/SectionLocked.constants";
import { COMMON_WIDTH_RESOLUTIONS } from "features/Common/modules/ExlyImage/constants/ExlyImage.constants";

export const SectionLocked = () => {
  return (
    <ExlyImage
      className={`tw-w-[66px] tw-h-[24px]`}
      src={locked_svg}
      fetchWidth={COMMON_WIDTH_RESOLUTIONS.WIDTH_360}
    />
  );
};
